import { componentHelpers } from '@approvalmax/utils';
import { useMemo } from 'react';
import { useToggle } from 'react-use';

import { Button, Menu } from '../../../../components';
import { DotsFilledIcon } from '../../../../icons';
import { BaseItem } from '../../Table.types';
import { RowActionMenuCell, RowActionMenuCellContent } from './BodyRowActionMenu.styles';
import { BodyRowActionMenuProps } from './BodyRowActionMenu.types';

export const BodyRowActionMenu = componentHelpers.genericMemo(
    <Item extends BaseItem>(props: BodyRowActionMenuProps<Item>) => {
        const { actions, item, progress, bordered, cellRef } = props;

        const [open, toggleOpen] = useToggle(false);

        const visibleActions = useMemo(() => {
            return actions.filter((action) => !action.isHidden?.(item));
        }, [actions, item]);

        const hasVisibleActions = visibleActions.length > 0;

        if (progress) {
            return <RowActionMenuCell $bordered={bordered} />;
        }

        return (
            <RowActionMenuCell ref={cellRef} $bordered={bordered}>
                {hasVisibleActions && (
                    <RowActionMenuCellContent
                        $open={open}
                        activator={
                            <Button icon variant='text' color='blue100'>
                                <DotsFilledIcon size={20} />
                            </Button>
                        }
                        width='max-content'
                        height='max-content'
                        open={open}
                        onOpen={toggleOpen}
                    >
                        <Menu size='small'>
                            {visibleActions.map((action, index) => (
                                <Menu.Item
                                    key={index}
                                    name={action.label}
                                    title={action.label}
                                    onClick={(event) => {
                                        event.stopPropagation();

                                        action.onClick(item);
                                        toggleOpen(false);
                                    }}
                                    disabled={
                                        typeof action.disabled === 'function' ? action.disabled(item) : action.disabled
                                    }
                                />
                            ))}
                        </Menu>
                    </RowActionMenuCellContent>
                )}
            </RowActionMenuCell>
        );
    }
);

BodyRowActionMenu.displayName = 'BodyRowActionMenu';
